import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Polygon, { points: "3 11 22 2 13 21 11 13 3 11", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Navigation";
const Navigation = memo(themed(Icon));
export {
  Navigation
};
//# sourceMappingURL=navigation.js.map
